import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "iframeContainer"];
  static values = { videoId: String };

  connect() {
    // Bind once and (re)attach. Identical listener references are de-duped by the
    // browser, so this stays correct even when relocation re-triggers connect().
    this.boundStopVideo ||= this.stopVideo.bind(this);
    this.element.addEventListener("hidden.bs.modal", this.boundStopVideo);

    // Relocate the modal to <body> so Bootstrap's backdrop can't trap it behind a
    // stacking context. Guarded so the move (which re-triggers connect) can't loop.
    if (this.element.parentElement !== document.body) {
      document.body.appendChild(this.element);
    }
  }

  disconnect() {
    // Clean up event listeners safely
    if (this.boundStopVideo) {
      this.element.removeEventListener("hidden.bs.modal", this.boundStopVideo);
    }
  }

  playVideo() {
    const videoId = this.videoIdValue;
    const iframeContainer = this.iframeContainerTarget;
    const preview = this.previewTarget;

    // Inject the real YouTube iframe dynamically with autoplay enabled
    iframeContainer.innerHTML = `
      <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&rel=0" 
              title="Video Tutorial" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowfullscreen 
              class="w-100 h-100"></iframe>
    `;

    // Swap views smoothly
    preview.classList.add("d-none");
    iframeContainer.classList.remove("d-none");
  }

  stopVideo() {
    // Unload the iframe completely to stop video & audio playback instantly, and restore preview thumbnail
    if (this.hasIframeContainerTarget && this.hasPreviewTarget) {
      this.iframeContainerTarget.innerHTML = "";
      this.iframeContainerTarget.classList.add("d-none");
      this.previewTarget.classList.remove("d-none");
    }
  }
}
